/* Header types */
type HeaderType = {
  headerType?: HeaderTypeEnum;
};

export type HeaderTextType = {
  text: string;
};

export type HeaderLogoType = {
  altText: string;
  url: string;
};

export enum HeaderTypeEnum {
  STANDARD = 0,
  PREMIUM = 10,
}

export type HeaderImagePropsType = HeaderLogoType & HeaderType;

export type HeaderTextPropsType = HeaderTextType & HeaderType;

export type HeaderPropsType = {
  premium: boolean;
  standard: boolean;
  headerLogoUrl: string;
  headerText: string;
  endPageIsEnabled: boolean;
};
